import * as React from "react";

import {
  createNativeStackNavigator,
  NativeStackScreenProps,
} from "@react-navigation/native-stack";
import DiscountsScreen from "./DiscountsScreen";
import SpecificCategory from "./SpecificCategory";

export type DiscountStackNavParamList = {
  DiscountHome: undefined;
  Specific: { category: string };
};
const DiscountStackNav =
  createNativeStackNavigator<DiscountStackNavParamList>();
export type DiscountStackProps = NativeStackScreenProps<
  DiscountStackNavParamList,
  "DiscountHome"
>;
export type SpecificCategoryScreenProps = NativeStackScreenProps<
  DiscountStackNavParamList,
  "Specific"
>;
const DiscountStack = () => {
  return (
    <DiscountStackNav.Navigator
      screenOptions={{ headerShown: false }}
      initialRouteName="DiscountHome"
    >
      <DiscountStackNav.Screen
        name="DiscountHome"
        component={DiscountsScreen}
      />
      <DiscountStackNav.Screen name="Specific" component={SpecificCategory} />
    </DiscountStackNav.Navigator>
  );
};

export default DiscountStack;
